/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Create_Team_TitleInputs */



/**
* | output |
* | --- |
* | "Work together as a team" |
*
* @param {Team_Manager_Create_Team_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_create_team_title = /** @type {((inputs?: Team_Manager_Create_Team_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Create_Team_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Travaillez en équipe")
	if (locale === "de") return /** @type {LocalizedString} */ ("Arbeiten Sie im Team")
	if (locale === "it") return /** @type {LocalizedString} */ ("Lavora in team")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Работайте командой")
	if (locale === "es") return /** @type {LocalizedString} */ ("Trabaja en equipo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("以团队方式协作")
	if (locale === "ja") return /** @type {LocalizedString} */ ("チームで作業しましょう")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एक टीम के रूप में काम करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Trabalhe em equipa")
	return /** @type {LocalizedString} */ ("Work together as a team")
});